module.exports = __webpack_public_path__ + "media/components/breakheader/static/icon--s4-212c8f80a0ef3ad8a72006033804f79a.svg";